import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import TractorAPI from "../api/Tractor.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { TableColumn, Tractor } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Tractor>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(tractor: Tractor): JSX.Element[] {
  return [
    <TableCell key={"name"}>{tractor.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(tractor.createdAt)}</TableCell>,
  ];
}

export default function TractorList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Tractors</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={TractorAPI.useList}
          modelBaseUrl={"tractors"}
          columns={columns}
          buildTableRow={buildTableRow}
        />
        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={TractorAPI.useSave}
          navigateUrl="/tractors"
        />
      </Box>
    </Layout>
  );
}
